<template>
    <div class="edit-user">
        <admin-layout>
            <app-content-pane class="ml-3">
                <template #title>
                    <div class="px-4 pt-3">
                        <h1>{{ is_create_organization ? 'Create Organization' : 'Edit Organization' }}</h1>
                        <nav>
                            <ol class="breadcrumb">
                                <li class="breadcrumb-item">
                                    <a :href="route('organization.index', {...global_url_params})">Organizations</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ is_create_organization ? 'Create Organization' : 'Edit Organization' }}
                                </li>
                            </ol>
                        </nav>
                    </div>
                </template>

                <hr>

                <form action="#" method="post" @submit.prevent="saveOrganization()" class="form">
                    <section class="px-4 py-3">

                        <div class="form-area">
                            <template v-if="is_create_organization && !form.create_new_organization">
                                <div class="form-group">
                                    <label for="organization_name">Search for Organization</label>
                                    <input type="text"
                                           placeholder="Keywords"
                                           class="form-control"
                                           v-model="search.q">
                                </div>
                                <div class="search-results">
                                    <div class="options">
                                        <div class="custom-control custom-radio search-item" v-for="item in search.results" :key="item.id">
                                            <template v-if="item.type === 'org'">
                                                <input type="radio"
                                                       :id="`search-item-${item.id}`"
                                                       name="search-item"
                                                       v-model="search.selected"
                                                       :value="item.id"
                                                       class="custom-control-input">
                                                <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                    <strong>{{ item.value.name }}</strong>
                                                    <div>{{ item.value.meta?.address }}</div>
                                                </label>
                                            </template>
                                            <template v-if="item.type === 'ac'">
                                                <input type="radio"
                                                       :id="`search-item-${item.id}`"
                                                       name="search-item"
                                                       v-model="search.selected"
                                                       :value="item.id"
                                                       class="custom-control-input">
                                                <label class="custom-control-label" :for="`search-item-${item.id}`">
                                                    <strong>{{ item.value?.structured_formatting?.main_text }}</strong>
                                                    <div>{{ item.value?.structured_formatting?.secondary_text }}</div>
                                                </label>
                                            </template>
                                        </div>

                                        <p class="mt-3" v-if="!search.is_busy">
                                            Can't find your organization or place?
                                            <a @click.prevent.stop="form.create_new_organization = true"
                                               href="#">Create new organization</a>.
                                        </p>

                                    </div>
                                </div>
                            </template>

                            <template v-if="is_edit_organization || form.create_new_organization">
                                <div class="form-group">
                                    <label for="organization_name">Organization Name</label>
                                    <input id="organization_name"
                                           type="text"
                                           placeholder="Organization Name"
                                           class="form-control"
                                           v-model="form.name">
                                    <error-line field="name"/>
                                </div>

                                <div class="form-group">
                                    <label for="organization_address">Address</label>
                                    <textarea id="organization_address"
                                              type="text"
                                              placeholder="Full Organization Address"
                                              class="form-control"
                                              v-model="form.address"/>
                                    <error-line field="address"/>
                                </div>

                                <template v-if="is_create_organization && form.create_new_organization">
                                    <p class="mt-3">
                                        Want to give search a try again?
                                        <a @click.prevent.stop="form.create_new_organization = false"
                                           href="#">Search for an existing organization or a place</a>.
                                    </p>
                                </template>

                            </template>

                            <div v-if="location" class="mb-3">
                                <GMapMap :center="location"
                                         :options="{}"
                                         class="map"
                                         :zoom="10">
                                    <GMapCluster>
                                        <GMapMarker :position="location" :clickable="false" :draggable="false"/>
                                    </GMapCluster>
                                </GMapMap>
                            </div>


                            <template v-if="is_admin">

                                <!-- Account Type -->
                                <div class="form-group">
                                    <label for="account-type">Account Type</label>
                                    <select id="account-type"
                                            class="form-control"
                                            v-model="form.account_type">
                                        <option value="free">Free</option>
                                        <option value="paid">Paid</option>
                                    </select>
                                    <error-line field="account_type"/>
                                </div>

                                <div class="form-group" v-if="form.account_type === 'paid'">
                                    <label for="account-trial_expire_at">Trial Expiry</label>
                                    <select id="account-trial_expire_at"
                                            class="form-control"
                                            v-model="form.trial_expire_at">
                                        <option :value="null">Never</option>
                                        <option v-for="day in trial_days" :value="day.value">
                                            {{ day.value }} -
                                            <template v-if="day.day === 0">
                                                Today
                                            </template>
                                            <template v-else>
                                                in {{ day.day }} day{{ day.day > 1 ? 's' : '' }}
                                            </template>
                                            <template v-if="day.value === organization.trial_expire_at"> (SELECTED)</template>
                                        </option>
                                    </select>
                                    <error-line field="trial_expire_at"/>
                                </div>

                            </template>


                            <div class="form-group">
                                <template v-if="selected?.type === 'org'">

                                    <div class="alert alert-warning">
                                        This organization is already registered.
                                    </div>

                                    <inertia-link class="btn btn-primary" :href="route('organization.edit', {organization: selected?.value?.id, ...global_url_params})">
                                        Edit Organization
                                    </inertia-link>
                                </template>
                                <template v-else>
                                    <state-button class="btn btn-primary"
                                                  type="submit"
                                                  :state="is_busy ? 'busy' : ''"
                                                  :disabled="is_busy">
                                        {{ is_create_organization ? 'Create New Organization' : 'Save Organization' }}
                                    </state-button>
                                </template>
                            </div>
                        </div>

                    </section>
                </form>

            </app-content-pane>
        </admin-layout>
    </div>
</template>

<script>
import AdminLayout from "@/Layouts/AdminLayout";
import AppContentPane from "@/Components/AppContentPane";
import ErrorLine from "@/Components/Common/ErrorLine";
import StateButton from "@/Components/Common/StateButton";
import API from "@/API";
import trial from "@/mixins/trial.js";
export default {
    name: "Edit",
    components: {StateButton, ErrorLine, AppContentPane, AdminLayout},
    mixins: [trial],
    props: ['organization'],

    data(){
        return {
            is_busy: false,

            debouncedSearch: _.debounce(() => this.searchOrganizations(), 300),

            search: {
                is_busy: false,
                q: '',
                results: [],
                selected: null,
            },

            form: this.$inertia.form({
                name: '',
                address: '',
                place_id: '',
                lat: '',
                lng: '',
                create_new_organization: false,
                account_type: 'free',
                trial_expire_at: null,
            }),


            trial_days: [],

        }
    },


    computed: {

        search_query(){
            return this.search.q;
        },

        selected(){
            return this.search.results.find(org => org.id === this.search.selected);
        },

        is_create_organization(){
            return !this.is_edit_organization;
        },

        is_edit_organization(){
            return !!this.organization?.id;
        },

        location(){
            if( this.organization?.meta?.lat && this.organization?.meta?.lng ){
                return {
                    lat: this.organization.meta.lat,
                    lng: this.organization.meta.lng,
                };
            }
            return null;
        }
    },


    watch: {
        search_query(){
            this.debouncedSearch();
        },

        selected(org){

            this.form.name      = '';
            this.form.address   = '';
            this.form.place_id  = '';
            this.form.lat       = '';
            this.form.lng       = '';

            if (org?.type === 'org') {

                this.form.name = org.value?.name;
                this.form.address = org.value?.meta?.address;
                this.form.place_id  = org.value?.meta?.place_id;

            }else if (org?.type === 'ac') {

                this.form.name = org.value?.name;
                this.form.address = org.value?.meta?.address;
                this.form.place_id  = org.value?.place_id;

            }
        },

        organization: {
            deep: true,
            handler(){
                this.$forceUpdate();
            }
        }

    },

    methods: {

        formatDate(date){
            if( typeof date === 'string' ){
                date = new Date( Date.parse( date ) );
            }
            return `${date.getUTCFullYear()}-${(date.getUTCMonth() + 1).toString().padStart(2, '0')}-${date.getUTCDate().toString().padStart(2, '0')}`;
        },

        async searchOrganizations(){

            this.search.is_busy = true;
            try{
                this.search.selected = null;
                this.search.results = [];
                if( this.search.q && this.search.q.length ){
                    this.search.results = await API.organizations.search({q: this.search.q});
                }
            }catch (e) {}
            this.search.is_busy = false;
        },

        async createOrganization(){
            this.form.post(this.route( 'organization.store', {...this.global_url_params}), {
                onStart: () => this.is_busy = true,
                onSuccess: this.refresh,
                onFinish: () => this.is_busy = false,
            });
        },

        async updateOrganization(){
            this.form.put(this.route('organization.update', {organization: this.organization.id, ...this.global_url_params}), {
                onStart: () => this.is_busy = true,
                onSuccess: this.back,
                onFinish: () => this.is_busy = false,
            });
        },

        async saveOrganization(){
            if( this.is_create_organization ){
                await this.createOrganization();
            }else{
                await this.updateOrganization();
            }
        },

        refresh(){
            if( this.is_edit_organization ){
                this.form.name = this.organization.name;
                this.form.address = this.organization.meta.address;
                this.form.account_type = this.organization.account_type;
                this.form.trial_expire_at = this.organization.trial_expire_at;
            }

            let saved_trial_day = null;
            if( this.form.trial_expire_at ){
                saved_trial_day = {
                    value: this.formatDate( this.form.trial_expire_at ),
                    day: this.organization.trial_expires_in,
                }
            }

            let added_saved = false;
            for (const day of this.trial_days_options){

                // Skip the loop if it is already saved in the user's trial date.
                if( ! added_saved && saved_trial_day && day >= saved_trial_day.day ){
                    this.trial_days.push(saved_trial_day);
                    added_saved = true;

                    if( day === saved_trial_day.day ){
                        continue;
                    }
                }

                const date = new Date();
                date.setDate( date.getDate() + day );
                const date_formatted = this.formatDate(date);

                this.trial_days.push({value: date_formatted, day});
            }

        },


        back(){
            // window.history.back();
            console.log({inertia: this.$inertia, referer: document.referrer, history: window.history});
        }

    },

    mounted() {
        this.refresh();
        this.setTitle( this.form.name );
    }

}
</script>

<style lang="scss" scoped>
.form-area{
    max-width: 800px;
}
.map{
    width: 100%;
    height: 320px;
}
.search-item{
    border-bottom: $light-borders solid 1px;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
}
</style>
